export const environment = {
  production: false,
  // API_BASE_URL: "https://7bg84htnfd.execute-api.us-west-1.amazonaws.com/devnew/",
  // https://4ruyevzr13.execute-api.us-west-1.amazonaws.com/dev/
  // API_BASE_URL: "https://5qhum71cc6.execute-api.us-west-1.amazonaws.com/stage/",
  // http://192.168.194.58:3000/dev/
  // API_BASE_URL: "http://0.0.0.0:3000/dev/",
  // API_BASE_URL: "https://8hxm0msog8.execute-api.us-west-1.amazonaws.com/prod/",
  // API_BASE_URL: "http://localhost:3000/dev/",
  API_BASE_URL: "https://apis.equip.noritz.com/",
  // NORITZ_SUPPORT_API_URL:"https://support.noritz.app/api/docs/heaters/",


  PAYLOAD_ENC_KEY: "Xn2r5u8x-A-D(GERTKaPdSEEWVkYp@#s6v9y$B&E)H++MbQeThWmZq4t7w!z%C*F-JaNdR",
  BUCKET_URL: "https://noritz-equip-assets.s3.us-west-1.amazonaws.com/",
  BUCKET_NAME: "noritz-equip-assets",
  BUCKET_ACCESS_KEY: "AKIAQVJIXGIWOQ55V4TG",
  BUCKET_SECRET: "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",
  BUCKET_REGION: "us-west-1",
};


